(() => {
  let busy = false;
  const rankCards = (section) => {
    const progress = section.closest('form')?.querySelector('[data-qz-extra-progress]');
    const gap = progress?.dataset.shippingReady === 'true' && section.dataset.liveSale !== 'true' && progress.dataset.qualified !== 'true'
      ? Math.max(0, Number(progress.dataset.shippingThreshold) - Number(progress.dataset.orderTotal)) : 0;
    const cards = [...section.querySelectorAll('[data-qz-addon-card]')];
    cards.sort((a, b) => {
      const ap = Number(a.dataset.price), bp = Number(b.dataset.price);
      const ac = gap > 0 && ap >= gap, bc = gap > 0 && bp >= gap;
      if (ac !== bc) return ac ? -1 : 1;
      if (ac && ap !== bp) return ap - bp;
      return Number(b.dataset.score) - Number(a.dataset.score);
    });
    const chosen = [];
    const families = new Set();
    cards.forEach(card => {
      if (chosen.length < 2 && !families.has(card.dataset.family)) {
        chosen.push(card);
        families.add(card.dataset.family);
      }
    });
    cards.forEach(card => {if (chosen.length < 2 && !chosen.includes(card)) chosen.push(card);});
    const grid = section.querySelector('.qz-addon-grid');
    [...chosen, ...cards.filter(card => !chosen.includes(card))].forEach(card => {
      card.hidden = !chosen.includes(card);
      grid.appendChild(card);
    });
  };
  const sync = () => document.querySelectorAll('[data-qz-cart-addons]').forEach(rankCards);
  const refreshCart = async (root, config) => {
    const api = window.Shopify?.theme;
    const state = api?.cart?.getCart
      ? await api.cart.getCart()
      : await fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store'}).then(r => {if (!r.ok) throw new Error('Cart unavailable'); return r.json();});
    const response = await fetch((config.cart_url || root + 'cart') + '/?view=ajax', {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('Cart unavailable');
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('template[data-html="content"]');
    if (!content) throw new Error('Cart unavailable');
    const positions = [...document.querySelectorAll('.qz-cart-body')].map(el => [el, el.scrollTop]);
    document.querySelectorAll('.js-ajax-cart-content').forEach(el => {el.innerHTML = content.innerHTML;});
    document.querySelectorAll('.js-cart-count').forEach(el => {el.textContent = state.item_count; el.classList.toggle('cart-empty', state.item_count === 0);});
    api?.ajaxCart?.cartEvents(config);
    sync();
    positions.forEach(([el, top]) => {el.scrollTop = top;});
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-qz-addon-add]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.disabled) return;
    busy = true;
    const section = button.closest('[data-qz-cart-addons]');
    const status = section.querySelector('.qz-addon-status');
    status.hidden = true;
    const hadFocus = document.activeElement === button;
    const inDrawer = Boolean(section.closest('#mini-cart'));
    const root = window.Shopify?.routes?.root || '/';
    const title = button.dataset.title;
    const successLabel = section.dataset.successLabel;
    let added = false;
    let config = {};
    try {
      config = JSON.parse(document.getElementById('cart-config')?.textContent || '{}');
      document.querySelectorAll('[data-qz-addon-add]').forEach(el => {el.disabled = true;});
      button.textContent = section.dataset.addingLabel;
      const response = await fetch(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.variant),quantity:1}]})});
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || section.dataset.errorLabel);
      added = true;
      button.textContent = section.dataset.addedLabel;
      await refreshCart(root, config);
      const announcer = document.getElementById('qz-addon-announcer');
      if (announcer) announcer.textContent = successLabel.replace('[title]', title);
      if (hadFocus) {
        const scope = inDrawer ? document.getElementById('mini-cart') : document.querySelector('main');
        const target = scope?.querySelector('[data-qz-cart-addons] h3') || scope?.querySelector('.ajax-cart__button-submit');
        target?.focus({preventScroll:true});
      }
    } catch (error) {
      if (added) {
        window.location.assign(config.cart_url || root + 'cart');
        return;
      }
      status.textContent = error.message || section.dataset.errorLabel;
      status.hidden = false;
      button.textContent = section.dataset.addLabel;
    } finally {
      busy = false;
      document.querySelectorAll('[data-qz-addon-add]').forEach(el => {el.disabled = false;});
    }
  });
  const start = () => {
    sync();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-qz-cart-addons]') || node.querySelector('[data-qz-cart-addons]'))))) sync();
    }).observe(document.body,{childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
